import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { SearchTitleV2 } from '../../../../vtex-apps/search-result/SearchTitleV2/default';
import { TotalProductsV2 } from '../../../../vtex-apps/search-result/TotalProductsV2/default';
import { FilterNavigatorV3 } from '../../../../vtex-apps/search-result/FilterNavigatorV3/default';
import { OrderByV2 } from '../../../../vtex-apps/search-result/OrderByV2/default';
import { Gallery } from '../../../../vtex-apps/search-result/Gallery/default';
import { SearchContent } from '../../../../vtex-apps/search-result/SearchContent/default';

//this one is slightly different, this will be called from the default.js of the component
//and the component renderer will call that default.js
//thats why i left the props object this way

export default function SearchResultLayoutMobile() {
	return {
		componentName: 'SearchResultLayoutMobile',
		componentId: uuidv4(),
		componentGroup: 'SearchResultLayoutMobile',
		variables,
		props: {
			blockClass: 'srl__mobile-1',
			title: 'MZ | Resultado de Busca Mobile',
		},
		childrenComponents: [
			{
				componentGroup: 'BreadcrumbGroup',
				componentName: 'FlexLayoutRow',
				componentId: uuidv4(),
			},
			FlexLayoutRow(
				{
					blockClass: 'row__search-container',
					fullWidth: true,
					colGap: {
						desktop: 0,
						tablet: 0,
						phone: 0,
					},
				},
				[
					FlexLayoutRow(
						{
							blockClass: 'row__title',
							colGap: {
								desktop: 0,
								tablet: 0,
								phone: 0,
							},
						},
						[SearchTitleV2()],
					),
					//NOTE - search info
					FlexLayoutRow(
						{
							blockClass: 'row__search-info',
							colGap: {
								desktop: 0,
								tablet: 2,
								phone: 2,
							},
							preventHorizontalStretch: true,
						},
						[TotalProductsV2()],
					),
					//NOTE - Total product
					FlexLayoutRow(
						{
							blockClass: 'row__total-product',
							colSizing: 'equals',
							colGap: {
								desktop: 0,
								tablet: 0,
								phone: 0,
							},
							preserveLayoutOnMobile: true,
						},
						[OrderByV2(), FilterNavigatorV3()],
					),
					FlexLayoutRow(
						{
							blockClass: 'row__search-result',
							fullWidth: true,
						},
						[
							SearchContent(
								{},
								[],
								[
									Gallery({
										layouts: [
											{
												name: 'grid',
												component: 'GridSummary',
												itemsPerRow: {
													desktop: 3,
													tablet: 3,
													phone: 2,
												},
											},
										],
										GridSummary: {
											componentGroup: 'ProductSummaryShelf',
											componentName: 'ProductSummaryShelfComponent',
											componentId: uuidv4(),
										},
									}),
								],
							),
						],
					),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--text-color-1', to: '--srlm-1-title-color', name: 'Cor do título' },
			{ from: '--text-color-1', to: '--srlm-1-title-qtd-color', name: 'Cor da qtd de produtos' },
			{ from: '--text-color-1', to: '--srlm-1-title-orderby-color', name: "Cor do 'ordenar Por'" },
			{
				from: '--neutral-color-high-dark',
				to: '--srlm-1-orderby-border-color',
				name: "Cor de borda do 'ordenar Por'",
			},
			{
				from: '--brand-color-primary-pure',
				to: '--srlm-1-orderby-arrow-color',
				name: "Cor da arrow do 'ordenar Por'",
			},
			//cor bg ordenar por
			{ from: '--transparent', to: '--srlm-1-orderby-bg', name: "Cor de fundo do 'ordenar Por'" },
			{ from: '--text-color-1', to: '--srlm-1-options-title-color', name: 'Cor dos títulos das opções' },
			{ from: '--text-color-1', to: '--srlm-1-filter-title-color', name: 'Cor dos textos das opções' },
			{ from: '--brand-color-primary-pure', to: '--srlm-1-filter-btn-bg', name: 'Background botão filtrar' },
			{ from: '--white', to: '--srlm-1-filter-btn-text', name: 'Texto botão filtrar' },
			{
				from: '--brand-color-primary-pure',
				to: '--srlm-1-details-color',
				name: 'Cor dos detalhes do filtro lateral',
			},
			{ from: '--brand-color-primary-pure', to: '--srlm-1-checkpoint-bg', name: 'Check Bg' },
			{ from: '--brand-color-primary-pure', to: '--srlm-1-checkpoint', name: 'Check' },
			//cor bg aplicar
			{ from: '--brand-color-primary-pure', to: '--srlm-1-apply-bg', name: "Cor bg 'Aplicar'" },
			//cor bg hover aplicar
			{ from: '--brand-color-primary-light', to: '--srlm-1-apply-hover-bg', name: "Cor bg hover 'Aplicar'" },
			//cor texto aplicar
			{ from: '--white', to: '--srlm-1-apply-text', name: "Cor texto 'Aplicar'" },
			//cor borda aplicar
			{ from: '--white', to: '--srlm-1-apply-border', name: "Cor borda 'Aplicar'" },

			//cor bg limpar
			{ from: '--brand-color-secondary-pure', to: '--srlm-1-clear-bg', name: "Cor bg 'Limpar'" },
			//cor bg hover limpar
			{ from: '--brand-color-secondary-light', to: '--srlm-1-clear-hover-bg', name: "Cor bg hover 'Limpar'" },
			//cor texto limpar
			{ from: '--text-color-1', to: '--srlm-1-clear-text', name: "Cor texto 'Limpar'" },
			//cor borda limpar
			{ from: '--text-color-1', to: '--srlm-1-clear-border', name: "Cor borda 'Limpar'" },
		],
	},
	//borderRadius
	{
		type: 'borderRadius',
		list: [
			//aplicar border radius
			{ from: '--border-radius-xs', to: '--srlm-1-apply-border-radius', name: "Border radius 'Aplicar'" },
			//limpar border radius
			{ from: '--border-radius-xs', to: '--srlm-1-clear-border-radius', name: "Border radius 'Limpar'" },
		],
	},
	//fontWeight
	{
		type: 'fontWeight',
		list: [
			//aplicar font weight
			{ from: '--font-weight-400', to: '--srlm-1-apply-fw', name: "Peso 'Aplicar'" },
			//limpar font weight
			{ from: '--font-weight-400', to: '--srlm-1-clear-fw', name: "Peso 'Limpar'" },
			//peso titulo galeria
			{ from: '--font-weight-400', to: '--srlm-1-title-fw', name: 'Peso do título' },
		],
	},
	//typography
	{
		type: 'typography',
		list: [
			//apply
			{ from: '--main-font', to: '--srlm-1-apply-ff', name: "Tamanho 'Aplicar'" },
			//clear
			{ from: '--main-font', to: '--srlm-1-clear-ff', name: "Tamanho 'Limpar'" },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-lg', to: '--srlm-1-title-size', name: 'Tamanho do título' },
			{ from: '--font-size-sm', to: '--srlm-1-title-qtd-size', name: 'Tamanho da qtd de produtos/ordenar' },
			{ from: '--font-size-xs', to: '--srlm-1-title-orderby-size', name: "Tamanho do 'ordenar Por'" },
			{ from: '--font-size-md', to: '--srlm-1-filter-title-size', name: "Tamanho do título 'Filtros'" },
			{ from: '--font-size-xs', to: '--srlm-1-options-title-size', name: 'Tamanho dos títulos das opções' },
			{ from: '--font-size-xxs', to: '--srlm-1-options-text-size', name: 'Tamanho dos textos das opções' },
			//aplicar
			{ from: '--font-size-xs', to: '--srlm-1-apply-fs', name: "Tamanho do 'Aplicar'" },
			//limpar
			{ from: '--font-size-xs', to: '--srlm-1-clear-fs', name: "Tamanho do 'Limpar'" },
		],
	},
];
